import React, { useState } from "react";
import { Link , useNavigate, useLocation } from "react-router-dom";

import { Logout } from "../../api/authApi";
import { useAuth } from "../../context/authContext";

function SideBar({open, setOpen}) {
  const navigate = useNavigate();
  const location = useLocation();

  const { setUser, user} = useAuth();
  
  // const [open, setOpen] = useState(true);

  const [openAppMenu, setOpenAppMenu] = useState(false);

  const handleLogout =  async()=>{
    try { 
      const data =  await Logout();
    setUser(null);             
    navigate("/login", { replace: true });
    } catch (error) {
      console.log(error); 
    }
  }





  return (
    <>
  
      <aside className={`admin-home-sidebar-bg ${open ? "open" : ""}`}   >
        <div className="admin-home-sidebar-main">

          <ul>
            <li> <Link  to="/dashboard" > <i className="fa-solid fa-square-binary"></i> Dashboard </Link></li> 
            <li>  <Link to="/dashboard/verifyed-booking">   <i className="fa-solid fa-box-open"></i> Bookings </Link></li>

            <li className={location.pathname.startsWith("/dashboard/partner-leads") ? "active-nav-item" : ""}>  <Link to="/dashboard/partner-leads">   <i className="fa-solid fa-handshake"></i> Partner Leads </Link></li>

            <li>   <Link to=""> <i className="fa-solid fa-circle-dollar-to-slot"></i> Payments  </Link></li>

            <li className={location.pathname.startsWith("/dashboard/setting") ? "active-nav-item" : ""}><Link to="/dashboard/setting"> <i className="fa-solid fa-users-gear"></i> Partner Management </Link></li>

            <li className={location.pathname.startsWith("/dashboard/admin-manager") ? "active-nav-item" : ""}><Link to="/dashboard/admin-manager"> <i className="fa-solid fa-user-shield"></i> Admin Manager </Link></li>

           <div className="side-nav-manage-app-menu-row"   onClick={() => setOpenAppMenu(!openAppMenu)} > <i className="fa-brands fa-app-store"></i> Manage App Content      <i className={`fa-solid fa-chevron-${    openAppMenu ? "up" : "down" }`} ></i> </div>


              {openAppMenu && (
                <div className="sidenav-submenu">
                  <Link className="sidenav-submenu-item" to="/dashboard/app/bike">
                    Bike Service
                  </Link>

                  <Link className="sidenav-submenu-item" to="/dashboard/app/ac">
                    AC Service
                  </Link>

                  <Link className="sidenav-submenu-item" to="/dashboard/app/pet">
                    Pet Grooming
                  </Link>

                  <Link className="sidenav-submenu-item" to="/dashboard/app/men">
                    Mens Grooming
                  </Link>

                  <Link className="sidenav-submenu-item" to="/dashboard/manage-app-policy-details">
                    Manage App Policy Details
                  </Link>
                </div>
              )}


          </ul>
        </div>

        <div className="sidebar-profile">
          <div className="profile-info">
            <div className="profile-avatar">
              <i className="fa-solid fa-user"></i>
            </div>

            <div className="profile-text">
              <p className="profile-name">{user?.role}</p>
              <span className="profile-role">{user?.mobileNumber} </span>
            </div>
          </div>

          <button className="logout-btn" onClick={handleLogout}>
            <i className="fa-solid fa-right-from-bracket"></i>
            Logout
          </button>
        </div>

       
      </aside>



      {/* Overlay (mobile) */}
      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)} />}
    </>
  );
}

export default SideBar;
